// extracted by mini-css-extract-plugin
export default {"singlePropertyHeader":"SinglePropertyHeader_singlePropertyHeader__WQYTd","singlePropertyHeader__btn":"SinglePropertyHeader_singlePropertyHeader__btn__V85TM"};